import React from 'react'
import type { Form } from 'formular'
import { Modal } from 'sb-modal'
import type { ModalVisibilityProps } from 'sb-modal'
import { useMemo } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import { FormularCheckbox } from 'components/_new/forms'

import ProductList, { ProductListProps } from './ProductList/ProductList'
import SkipOption, { SkipOptionProps } from './SkipOption/SkipOption'

import messages from './messages'


type SkipAMonthModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  form: Form<SkipAMonthModal.FormValues>
  products: ProductListProps['items']
  isProductsFetching: boolean
  skipOptions: Omit<SkipOptionProps, 'field'>[]
  firstName?: string
  isUnsubscribeFlow?: boolean
  onConfirm: () => void
  onContinue: () => void
}

const SkipAMonthModalView: React.FunctionComponent<SkipAMonthModalViewProps> = (props) => {
  const {
    form, products, isProductsFetching, skipOptions, firstName,
    isUnsubscribeFlow, onConfirm, onContinue, onClose,
  } = props

  const [ title, text ] = useMemo(() => {
    let title: ReactIntlMessage = isUnsubscribeFlow ? messages.unsubscribeTitle : messages.singleTitle
    let text: ReactIntlMessage = isUnsubscribeFlow ? messages.unsubscribeText : messages.singleText

    if (products && products.length) {
      text = isUnsubscribeFlow ? messages.unsubscribePersonalText : messages.singlePersonalText

      if (firstName) {
        title = {
          ...messages.personalTitle,
          values: { name: firstName },
        }
      }
    }

    return [ title, text ]
  }, [ firstName, products, isUnsubscribeFlow ])

  const ordinaryButtonProps = useMemo(() => {
    if (isUnsubscribeFlow) {
      return {
        title: messages.continueButton,
        onClick: onContinue,
      }
    }

    return null
  }, [ isUnsubscribeFlow, onContinue ])

  return (
    <Modal
      className="humbleBgColor"
      title={title}
      text={text}
      primaryButton={{
        title: messages.confirmButton,
        rightIcon: 'rightArrowSmall',
        onClick: onConfirm,
      }}
      ordinaryButton={ordinaryButtonProps}
      onClose={onClose}
      dataTestId="skipAMonthModal"
    >
      <Box mt={32} hideEmpty>
        <ProductList items={products} isFetching={isProductsFetching} />
      </Box>
      <Box mt={32}>
        {
          skipOptions.map(({ monthCount, restartDate }, index) => (
            <Box key={monthCount} mt={index > 0 ? 16 : null}>
              <SkipOption
                field={form.fields.monthCount}
                monthCount={monthCount}
                restartDate={restartDate}
              />
            </Box>
          ))
        }
      </Box>
      <Box mt={40}>
        <FormularCheckbox
          field={form.fields.remind}
          label={messages.remind}
          dataTestId="skipAMonthRemind"
        />
      </Box>
    </Modal>
  )
}


export default SkipAMonthModalView
